/*
 * @author: miaomingzhu
 * @description: 模块标题公用组件
*/
import {FC, useCallback} from 'react';
import cx from 'classnames';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {ubcProps} from '../../../services/pages/channel/channel.client';
import styles from './index.less';
interface TitleProps {
    title: string;
    className?: string;
    subTitle: string;
    moreLink: string;
    ubcExt?: ubcProps;
}
const Title: FC<TitleProps> = ({
    title = '',
    subTitle = '',
    moreLink = '',
    ubcExt = {} as any,
    className = '',
}) => {

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, swanUrl?: string) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: ubcExt?.page,
                value: ubcExt?.value,
                channelId: ubcExt?.pageSourceId,
                pageType: ubcExt?.pageType,
                moduleId: ubcExt?.valueId,
                moduleName: ubcExt?.valueTitle,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.MODULE,
                    // eslint-disable-next-line camelcase
                    value_id: ubcExt?.valueId,
                    // eslint-disable-next-line camelcase
                    value_title: ubcExt?.valueTitle,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [ubcExt, navigateToUrl]
    );
    return (
        <div className={cx(
            styles.titleParent,
            className
        )}
        >
            <div className={styles.titleContent}>
                {
                    title
                        ? (
                            <span className={styles.title}>
                                {title}
                            </span>
                        )
                        : null
                }
                {
                    subTitle
                        ? (
                            <span className={styles.subTitle}>
                                {subTitle}
                            </span>
                        )
                        : null
                }
            </div>
            {
                moreLink
                    ? (
                        <img
                            src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                            className={styles.rightMoreArrow}
                            onClick={() => {
                                handleClick(moreLink);
                            }}
                            data-show={
                                JSON.stringify({...ubcExt})
                            }
                        />
                    )
                    : null
            }
        </div>
    );
};

export default Title;
